import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { useAuth } from '../../../src/contexts/AuthContext';
import { useTranslation } from '../../../src/contexts/TranslationContext';
import { AgentWizard } from '../../../src/features/voice-agents/components/AgentWizard';
import type { VoiceAgent } from '../../../src/features/voice-agents/types';
import { colors } from '../../../src/theme/colors';

export default function OnboardingVoiceAgentScreen() {
  const { t } = useTranslation();
  const { currentOrganization } = useAuth();
  const orgId = currentOrganization?.id ?? '';

  function handleComplete(agent: VoiceAgent) {
    router.replace(`/voice-agents/${agent.id}?fromOnboarding=true`);
  }

  function handleCancel() {
    router.back();
  }

  return (
    <View style={styles.root} accessibilityLabel={t('voiceAgents.onboardingScreen.screenA11y')}>
      <AgentWizard
        organizationId={orgId}
        mode="onboarding"
        onComplete={handleComplete}
        onCancel={handleCancel}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: colors.background.primary,
  },
});
